export const ERA_COURSE_URL = '/era/#/initera'
export const ERA_LEARNER_TYPE = 'livedemy'
export const NOT_EXPIRED_STATUS = 'ITEM_NOT_EXPIRED'
export const EXPIRED_STATUS = 'ITEM_NOT_EXPIRED'
export const IMAGE_UPLOAD_MAX_SIZE = 0.512 // the file size is in mb taken by dropzone
export const CDN_BUSSINESSHEADER = 'ERA' // common for development and staging
export const THIRDPARTY_GOOGLE_USER = 'GOOGLE'
export const THIRDPARTY_FACEBOOK_USER = 'FACEBOOK'
export const LIVEDEMY_DEFAULT_USER_RIGHT = 'learner'
export const MAHADEMY_APP_ENV = 'mahademy'
var ssoUrl = ''
var ssoClientId = ''
var mkclLoginServerUrl = ''
var mkclLoginClientUrl = ''
var mkclSignupUrl = ''
var eraGatewayUrl = ''
var cdpCdnUrl = ''
var cdpUploadUrl = ''
var cdpDeleteUrl = ''
var paymentRequestUrl = ''
var shareOnMediaUrl = ''
var cdnClientHeader = ''
var facebookLoginAppId = ''
var googleSignInAppId = ''
var livedemyDefaultUser = ''
var defaultObjectCategory = ''
var mahademyExitUrl = ''
var instanceName = ''
var feedBackMail = ''
if (process.env.NODE_ENV === 'development') {
     ssoUrl = 'http://10.2.10.42:3030'
     ssoClientId = 'LiveDemy2'
     mkclLoginServerUrl = 'http://10.2.10.42:3030'
     mkclLoginClientUrl = 'http://10.2.10.42:3030/#/login'
     mkclSignupUrl = 'http://10.2.10.42:3030/#/register'
     eraGatewayUrl = 'http://10.2.10.42:3037/o/gatewayserver/getserverdatabylearner'
     cdpCdnUrl = 'http://10.2.10.230:3032/'
     cdpUploadUrl = 'https://livedemystg.mkcl.org/cdnupload/?s-o'
     cdpDeleteUrl = 'https://livedemystg.mkcl.org/cdndelete/o/deletefile'
     paymentRequestUrl = 'https://stagingups.mkcl.org/ups/upsHome/showWelcome'
     shareOnMediaUrl = 'http://localhost:8083/#/coursePage/'
     cdnClientHeader = 'LiveDemy'
     facebookLoginAppId = '241796203256981'
     googleSignInAppId = '844613137140-ac3fpcc37b20oi00mockao9h43mpu0f2.apps.googleusercontent.com'
     livedemyDefaultUser = 'LIVEDEMY'
     defaultObjectCategory = 'LIVEDEMY'
     mahademyExitUrl = ''
     instanceName = 'LIVEDEMY'
     feedBackMail = 'livedemysupport@mkcl.org'
} else if (process.env.NODE_ENV === 'staging') {
     ssoUrl = 'https://livedemystg.mkcl.org/loginserver'
     ssoClientId = 'LIVEDEMY_STG'
     mkclLoginServerUrl = 'https://livedemystg.mkcl.org/loginserver/'
     mkclLoginClientUrl = 'https://livedemystg.mkcl.org/sso/#/login'
     mkclSignupUrl = 'https://livedemystg.mkcl.org/sso/#/register'
     eraGatewayUrl = 'https://livedemystg.mkcl.org/gateway/o/gatewayserver/getserverdatabylearner'
     cdpCdnUrl = 'https://livedemystg.mkcl.org/cdpcdn/'
     cdpUploadUrl = 'https://livedemystg.mkcl.org/cdnupload/?s-o'
     cdpDeleteUrl = 'https://livedemystg.mkcl.org/cdndelete/o/deletefile'
     paymentRequestUrl = 'https://stagingups.mkcl.org/ups/upsHome/showWelcome'
     shareOnMediaUrl = 'https://livedemystg.mkcl.org/#/coursePage/'
     cdnClientHeader = 'LiveDemy' // common for development and staging
     facebookLoginAppId = '241796203256981'
     googleSignInAppId = '844613137140-ac3fpcc37b20oi00mockao9h43mpu0f2.apps.googleusercontent.com'
     livedemyDefaultUser = 'LIVEDEMY'
     defaultObjectCategory = 'LIVEDEMY'
     mahademyExitUrl = 'http://mahademy.mkcl.org/mahademy/'
     instanceName = 'LIVEDEMY'
     feedBackMail = 'livedemysupport@mkcl.org'
} else if (process.env.NODE_ENV === 'mkcl') {
     ssoUrl = 'https://learning.mkcl.org/loginserver'
     ssoClientId = 'LIVEDEMY_MKCL'
     mkclLoginServerUrl = 'https://learning.mkcl.org/loginserver/'
     mkclLoginClientUrl = 'https://learning.mkcl.org/sso/#/login' // unused
     mkclSignupUrl = 'https://learning.mkcl.org/sso/#/register' // unused
     eraGatewayUrl = 'https://learning.mkcl.org/gateway/o/gatewayserver/getserverdatabylearner'
     cdpCdnUrl = 'https://cdpcdn.mkcl.org'
     cdpUploadUrl = 'https://learning.mkcl.org/cdnupload/?s-o'
     cdpDeleteUrl = 'https://learning.mkcl.org/cdndelete/o/deletefile'
     paymentRequestUrl = 'https://stagingups.mkcl.org/ups/upsHome/showWelcome'
     shareOnMediaUrl = 'https://10.2.11.6:8083/#/coursePage/'
     cdnClientHeader = 'LIVEDEMYMKCL' // common for development and staging
     facebookLoginAppId = '241796203256981'
     googleSignInAppId = '844613137140-ac3fpcc37b20oi00mockao9h43mpu0f2.apps.googleusercontent.com'
     livedemyDefaultUser = 'LIVEDEMY'
     defaultObjectCategory = 'LIVEDEMY'
     mahademyExitUrl = ''
     instanceName = 'LIVEDEMY'
     feedBackMail = 'livedemysupport@mkcl.org'
} else if (process.env.NODE_ENV === 'production') {
     ssoUrl = 'https://livedemy.mkcl.org/loginserver'
     ssoClientId = 'LIVEDEMY'
     mkclLoginServerUrl = 'https://livedemy.mkcl.org/loginserver/'
     mkclLoginClientUrl = 'https://livedemy.mkcl.org/sso/#/login'
     mkclSignupUrl = 'https://livedemy.mkcl.org/sso/#/register'
     eraGatewayUrl = 'https://livedemy.mkcl.org/gateway/o/gatewayserver/getserverdatabylearner'
     cdpCdnUrl = 'https://livedemy.mkcl.org/cdpcdn/'
     cdpUploadUrl = 'https://livedemy.mkcl.org/cdnupload/?s-o'
     cdpDeleteUrl = 'https://livedemy.mkcl.org/cdndelete/o/deletefile'
     paymentRequestUrl = 'https://ups.mkcl.org/oasis/ups/upsHome/showWelcome'
     shareOnMediaUrl = 'https://livedemy.mkcl.org/#/coursePage/'
     cdnClientHeader = 'LIVEDEMYPROD'
     facebookLoginAppId = '241796203256981'
     googleSignInAppId = '844613137140-ac3fpcc37b20oi00mockao9h43mpu0f2.apps.googleusercontent.com'
     livedemyDefaultUser = 'LIVEDEMY'
     defaultObjectCategory = 'LIVEDEMY'
     mahademyExitUrl = ''
     instanceName = 'LIVEDEMY'
     feedBackMail = 'livedemysupport@mkcl.org'
} else if (process.env.NODE_ENV === 'mahademy') {
     ssoUrl = 'https://livedemystg.mkcl.org/loginserver'
     ssoClientId = 'MahaDemy'
     mkclLoginServerUrl = 'http://mahademy.mkcl.org/mahademy/loginserver/'
     mkclLoginClientUrl = 'https://livedemystg.mkcl.org/sso/#/login'
     mkclSignupUrl = 'https://livedemystg.mkcl.org/sso/#/register'
     eraGatewayUrl = 'http://mahademy.mkcl.org/gateway/o/gatewayserver/getserverdatabylearner'
     cdpCdnUrl = 'http://mahademy.mkcl.org/cdpcdn/'
     cdpUploadUrl = 'http://mahademy.mkcl.org/cdnupload/?s-o'
     cdpDeleteUrl = 'http://mahademy.mkcl.org/cdndelete/o/deletefile'
     paymentRequestUrl = 'https://stagingups.mkcl.org/ups/upsHome/showWelcome'
     shareOnMediaUrl = 'http://mahademy.mkcl.org/mahademy/#/coursePage/'
     cdnClientHeader = 'MahaDemy'
     facebookLoginAppId = '241796203256981'
     googleSignInAppId = '844613137140-ac3fpcc37b20oi00mockao9h43mpu0f2.apps.googleusercontent.com'
     livedemyDefaultUser = 'MAHADEMY'
     defaultObjectCategory = 'MAHADEMY'
     instanceName = 'MAHADEMY'
     mahademyExitUrl = 'http://mahademy.mkcl.org/login/#/home'
     feedBackMail = 'livedemysupport@mkcl.org'
} else if (process.env.NODE_ENV === 'mfslivedemy') {
     ssoUrl = 'https://mfslivedemy.mkcl.org/loginserver'
     ssoClientId = 'LIVEDEMY'
     mkclLoginServerUrl = 'https://mfslivedemy.mkcl.org/loginserver/'
     mkclLoginClientUrl = 'https://mfslivedemy.mkcl.org/sso/#/login'
     mkclSignupUrl = 'https://mfslivedemy.mkcl.org/sso/#/register'
     eraGatewayUrl = 'https://mfslivedemy.mkcl.org/gateway/o/gatewayserver/getserverdatabylearner'
     cdpCdnUrl = 'https://mfslivedemy.mkcl.org/cdpcdn/'
     cdpUploadUrl = 'https://mfslivedemy.mkcl.org/cdnupload/?s-o'
     cdpDeleteUrl = 'https://mfslivedemy.mkcl.org/cdndelete/o/deletefile'
     paymentRequestUrl = 'https://ups.mkcl.org/oasis/ups/upsHome/showWelcome'
     shareOnMediaUrl = 'https://mfslivedemy.mkcl.org/#/coursePage/'
     cdnClientHeader = 'LIVEDEMYPROD'
     facebookLoginAppId = '241796203256981'
     googleSignInAppId = '844613137140-ac3fpcc37b20oi00mockao9h43mpu0f2.apps.googleusercontent.com'
     livedemyDefaultUser = 'LIVEDEMY'
     defaultObjectCategory = 'LIVEDEMY'
     mahademyExitUrl = ''
     instanceName = 'mfslivedemy'
     feedBackMail = 'livedemysupport@mkcl.org'
} else if (process.env.NODE_ENV === 'marketing') {
     ssoUrl = 'https://marketinglivedemydemo.mkcl.org/loginserver'
     ssoClientId = 'LIVEDEMY'
     mkclLoginServerUrl = 'https://marketinglivedemydemo.mkcl.org/loginserver/'
     mkclLoginClientUrl = 'https://marketinglivedemydemo.mkcl.org/sso/#/login'
     mkclSignupUrl = 'https://marketinglivedemydemo.mkcl.org/sso/#/register'
     eraGatewayUrl = 'https://marketinglivedemydemo.mkcl.org/gateway/o/gatewayserver/getserverdatabylearner'
     cdpCdnUrl = 'https://marketinglivedemydemo.mkcl.org/cdpcdn/'
     cdpUploadUrl = 'https://marketinglivedemydemo.mkcl.org/cdnupload/?s-o'
     cdpDeleteUrl = 'https://marketinglivedemydemo.mkcl.org/cdndelete/o/deletefile'
     paymentRequestUrl = 'https://ups.mkcl.org/oasis/ups/upsHome/showWelcome'
     shareOnMediaUrl = 'https://marketinglivedemydemo.mkcl.org/#/coursePage/'
     cdnClientHeader = 'LIVEDEMYPROD'
     facebookLoginAppId = '241796203256981'
     googleSignInAppId = '844613137140-ac3fpcc37b20oi00mockao9h43mpu0f2.apps.googleusercontent.com'
     livedemyDefaultUser = 'LIVEDEMY'
     defaultObjectCategory = 'LIVEDEMY'
     mahademyExitUrl = ''
     instanceName = 'LIVEDEMY'
     feedBackMail = 'livedemy@mkcl.org'
} else if (process.env.NODE_ENV === 'mfsstaging') {
     ssoUrl = 'https://mfslivedemystg.mkcl.org/loginserver'
     ssoClientId = 'LIVEDEMY_STG'
     mkclLoginServerUrl = 'https://mfslivedemystg.mkcl.org/loginserver/'
     mkclLoginClientUrl = 'https://mfslivedemystg.mkcl.org/sso/#/login'
     mkclSignupUrl = 'https://mfslivedemystg.mkcl.org/sso/#/register'
     eraGatewayUrl = 'https://mfslivedemystg.mkcl.org/gateway/o/gatewayserver/getserverdatabylearner'
     cdpCdnUrl = 'https://mfslivedemystg.mkcl.org/cdpcdn/'
     cdpUploadUrl = 'https://mfslivedemystg.mkcl.org/cdnupload/?s-o'
     cdpDeleteUrl = 'https://mfslivedemystg.mkcl.org/cdndelete/o/deletefile'
     paymentRequestUrl = 'https://ups.mkcl.org/oasis/ups/upsHome/showWelcome'
     shareOnMediaUrl = 'https://mfslivedemystg.mkcl.org/#/coursePage/'
     cdnClientHeader = 'LiveDemy'
     facebookLoginAppId = '241796203256981'
     googleSignInAppId = '844613137140-ac3fpcc37b20oi00mockao9h43mpu0f2.apps.googleusercontent.com'
     livedemyDefaultUser = 'LIVEDEMY'
     defaultObjectCategory = 'LIVEDEMY'
     mahademyExitUrl = ''
     instanceName = 'mfslivedemy'
     feedBackMail = 'livedemysupport@mkcl.org'
}
export const SSO_URL = ssoUrl
export const SSO_CLIENT_ID = ssoClientId
export const MKCL_LOGIN_SERVER_URL = mkclLoginServerUrl
export const MKCL_LOGIN_CLIENT_URL = mkclLoginClientUrl
export const MKCL_SIGNUP_URL = mkclSignupUrl
export const ERA_GATEWAY_URL = eraGatewayUrl
export const CDP_CDN_URL = cdpCdnUrl
export const CDN_UPLOAD_URL = cdpUploadUrl
export const CDN_DELETE_URL = cdpDeleteUrl
export const PAYMENT_REQUEST_URL = paymentRequestUrl
export const SHARE_ON_MEDIA_URL = shareOnMediaUrl
export const CDN_CLIENTHEADER = cdnClientHeader
export const FACEBOOK_LOGIN_APP_ID = facebookLoginAppId
export const GOOGLE_SIGN_IN_APP_ID = googleSignInAppId
export const LIVEDEMY_DEFAULT_USER = livedemyDefaultUser
export const DEFAULT_OBJECT_CATEGORY = defaultObjectCategory
export const MAHADEMY_EXIT_URL = mahademyExitUrl
export const INSTANCE_NAME = instanceName
export const FEEDBACK_MAIL = feedBackMail
export const CDP_CDN_THUMBNAIL_URL = CDP_CDN_URL + 'thumbnail'



// WEBPACK FOOTER //
// ./src/components/common/constants.js